import React from 'react';

import Link from 'next/link';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import UseSlugRoute from 'hooks/use-slugroute';

import { CourseCurriculumService } from 'services/core';

import Badge from '@core/components/badge/Badge';
import Spinner from '@core/components/spinner/Spinner';

import { Progressing, Completed } from 'constants/content-status';

import EmptyCircle from 'assets/icons/empty-circle.svg';
import ArrowRight from 'assets/icons/arrow-right.svg';
import InProgressIcon from 'assets/icons/inprogress-circle.svg';
import CompletedIcon from 'assets/icons/completed-circle.svg';

import classes from './CourseCurriculum.module.scss';

const CourseCurriculum = ({ section }) => {
	const router = useRouter();
	const slugRoute = UseSlugRoute();
	const { data, isLoading } = useQuery(['course-curriculum', router?.query?.slug[0]], () =>
		CourseCurriculumService(router?.query?.slug[0])
	);

	return (
		<>
			{data && !isLoading ? (
				<div className={`${classes['curriculum-wrapper']}`}>
					{(!section || section === 'summary') && (
						<>
							<h3>What you will learn...</h3>
							<div className={`${classes['summary']}`}>
								{data.data?.what_user_learn?.map((item, index) => (
									<p key={index}>{item}</p>
								))}
							</div>
						</>
					)}
					{(!section || section === 'lectures') && (
						<>
							<div className={`${classes['lectures']}`}>
								{data.data.lectures.length > 0 &&
									data.data.lectures.map((lecture) => (
										<Link
											key={lecture.id}
											href={slugRoute(`/courses/${lecture.id}`, lecture.slug)}
											className={`${classes['lectures__event']} ${classes['lectures__event']} lectures__event  animated fadeInUp delay-3s `}>
											<div className={`${classes['lectures__event__icon']}`}>
												<i className="">
													{lecture.status === Completed || lecture.status === Progressing ? (
														lecture.status === Completed ? (
															<CompletedIcon />
														) : (
															<InProgressIcon />
														)
													) : (
														<EmptyCircle />
													)}
													{/* <EmptyCircle /> */}
												</i>
											</div>
											<div className={`${classes['lectures__event__content']} w-100`}>
												<div
													className={`${classes['lectures__event__content__title']} d-flex flex-row justify-content-between`}>
													<img src={lecture.image} alt={lecture.title} />
													<div
														className={`${classes['lectures__event__content__title__detail']} d-flex flex-column justify-content-between`}>
														<div
															className={`${classes['lectures__event__content__title__detail']} d-flex flex-row align-items-center`}>
															{(lecture.status === Completed || lecture.status === Progressing) && (
																<Badge status={lecture.status} />
															)}
															<h5>Course #{lecture.position}</h5>
														</div>
														<h4>{lecture.title}</h4>
													</div>
													<ArrowRight />
												</div>
												<div className={`${classes['lectures__event__description']}`}>
													<p>{lecture.short_introduction}</p>
												</div>
											</div>
										</Link>
									))}
							</div>
						</>
					)}
				</div>
			) : (
				<div className="d-flex flex-row align-items-center justify-content-center w-100 my-5 py-5">
					<Spinner />
				</div>
			)}
		</>
	);
};

export default CourseCurriculum;
